module.exports = __webpack_public_path__ + "img/menu-bottom-icon-polygon.f8b958c9.svg";